export default "__VITE_ASSET__WJmsstlT__"